module.exports = __webpack_public_path__ + "static/api-4cb1339eadc3597fb1b461c176bf44fc.png";